<template>
  <div>
    <slot name="activator" :toggle="toggle" />

    <b-modal
      :id="modalId"
      ref="modal"
      v-model="showModal"
      :title="$t('Upload attachment')"
      no-close-on-backdrop
      :hide-footer="pending"
      @close="item.reset()"
      @show="fetchData"
  >
      <transition v-if="pending" appear name="loading-bar">
        <loading-bar v-show="pending" />
      </transition>
    <template #modal-footer>
      <b-button
          :disabled="item.busy"
          type="submit"
          variant="primary"
          @click="handleSave"
      >
        {{ $t('Save') }}

        <b-spinner
            v-if="item.busy"
            small
        />
        <fa
            v-else
            class="ml-1"
            icon="save"
        />
      </b-button>
    </template>

    <b-form v-if="!pending" @submit.prevent="handleSave">
      <file-upload-form-group
          v-if="!id"
          v-model="item.file"
          :invalid-feedback="item.errors.get('file')"
          :label="$t('File')"
          :multiple="false"
          :state="item.errors.has('file') ? false : null"
      />

      <b-form-group
          :invalid-feedback="item.errors.get('description')"
          :label="$t('Description')"
          :state="item.errors.has('description') ? false : null"
          label-for="description"
      >
        <b-form-textarea
            id="description"
            v-model="item.description"
            :state="item.errors.has('description') ? false : null"
            name="description"
        />
      </b-form-group>

      <b-form-group
          :invalid-feedback="item.errors.get('tags')"
          :label="$t('Tags')"
          :state="item.errors.has('tags') ? false : null"
          label-for="tags"
      >
        <tags-select
            id="tags"
            v-model="item.tags"
            taggable
        />
      </b-form-group>
    </b-form>
  </b-modal>
  </div>
</template>
<script>
import FileUploadFormGroup from "@/components/FileUploadFormGroup";
import Form from '@/plugins/form'
import TagsSelect from "@/components/selects/TagsSelect";
import itemMixin from "@/mixins/itemMixin";

export default {
  name: 'UploadAttachment',
  components: {TagsSelect, FileUploadFormGroup},
  mixins: [itemMixin],
  props: {
    projectId: {
      type: [Number, String],
      required: true
    },
    modalId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      lazy: true,
      showModal: false,
      item: new Form({
        file: null,
        description: null,
        tags: []
      })
    }
  },
  computed: {
    resourceName() {
      return `projects/${this.projectId}/attachments`;
    }
  },
  methods: {
    afterCreate() {
      this.$refs.modal.hide();
    },

    afterUpdate() {
      this.afterCreate();
    },

    toggle() {
      this.showModal = !this.showModal;
    }
  }

}
</script>
